import { createAction, props } from '@ngrx/store';
import { LeadModel } from '../../models/Lead.model';

export enum LeadsActionTypes {
  getLeadsBegin = '[Messages] Get Leads begin',
  getLeadsSuccess = '[Messages] Get Leads success',
  getLeadsFail = '[Messages] Get Leads failure',

  setLeadAsReadBegin = '[Messages] Set Lead as Read begin',
  setLeadAsReadSuccess = '[Messages] Set Lead as Read success',
  setLeadAsReadFail = '[Messages] Set Lead as Read failure',
}

// ----------------- LEADS ------------------------
export const getLeadsBeginAction = createAction(LeadsActionTypes.getLeadsBegin);
export const getLeadsSuccessAction = createAction(
  LeadsActionTypes.getLeadsSuccess,
  props<{
    payload: LeadModel[];
  }>()
);
export const getLeadsFailAction = createAction(
  LeadsActionTypes.getLeadsFail,
  props<{ errors: any }>()
);

// SET AS READ
export const setLeadAsReadBeginAction = createAction(
  LeadsActionTypes.setLeadAsReadBegin,
  props<{ leadId: number }>()
);
export const setLeadAsReadSuccessAction = createAction(
  LeadsActionTypes.setLeadAsReadSuccess,
  props<{
    payload: LeadModel[];
  }>()
);
export const setLeadAsReadFailAction = createAction(
  LeadsActionTypes.setLeadAsReadFail,
  props<{ errors: any }>()
);
